// window['PivotViewer'] = undefined;
require('./pivotviewer.min.js');
let PivotViewer = window['PivotViewer'];
import { appConfig } from '../../insaweb.config'

export function loadPivotCollectionFactory(sessionid, performanceID){
	$('#pivotviewer').PivotViewer({
		Loader: new PivotViewer.Models.Loaders.CXMLLoader(appConfig.pivotViewerServiceAddress +"/InsaTest.cxml?PerformanceID="+ performanceID +"&CompIDs=&SessionID=" + sessionid), 
		//Loader: new PivotViewer.Models.Loaders.CXMLLoader("http://localhost/html5pivot/InsaTest.cxml")
	});
};



// WEBPACK FOOTER //
// ./app/insa-pivot/pivot_loader.ts